import { mapPlacePredictionToLegacy } from './googleMapsPlacesMapping';

/**
 * Obtiene el array de sugerencias del payload del BFF (tolerante a envoltorios).
 * @param {unknown} data
 * @returns {Array}
 */
function pickSuggestionsArray(data) {
  if (!data || typeof data !== 'object') return [];
  if (Array.isArray(data.suggestions)) return data.suggestions;
  if (Array.isArray(data.data?.suggestions)) return data.data.suggestions;
  return [];
}

/**
 * Obtiene el objeto placePrediction de una entrada de lista (formato Google/BFF o plano).
 * @param {unknown} entry
 * @returns {Object|null}
 */
function extractPlacePrediction(entry) {
  if (!entry || typeof entry !== 'object') return null;
  if (entry.placePrediction && typeof entry.placePrediction === 'object') return entry.placePrediction;
  if (entry.placeId != null || entry.place_id != null || entry.text != null) return entry;
  return null;
}

/**
 * Normaliza la respuesta del POST autocomplete del BFF al formato legacy que usa LocationSection
 * (`place_id`, `description`, `structured_formatting`).
 *
 * @param {unknown} data - body JSON del BFF
 * @returns {Array<{ place_id: string, description: string, structured_formatting: object }>}
 */
export function normalizeBffAutocompleteResponseToLegacy(data) {
  const suggestions = pickSuggestionsArray(data);
  const out = [];

  suggestions.forEach((entry, index) => {
    const pred = extractPlacePrediction(entry);
    if (!pred) return;

    let legacy = mapPlacePredictionToLegacy(pred);
    if (!legacy) return;

    const placeId = legacy.place_id ?? pred.placeId ?? pred.place_id ?? `bff-suggestion-${index}`;
    const description =
      legacy.description ||
      (typeof pred.text === 'string' ? pred.text : pred.text?.text) ||
      [legacy.structured_formatting?.main_text, legacy.structured_formatting?.secondary_text]
        .filter(Boolean)
        .join(', ') ||
      '';

    legacy = {
      ...legacy,
      place_id: String(placeId),
      description: String(description)
    };

    out.push(legacy);
  });

  return out;
}
